<div class="modal-container">
  <div mat-dialog-title
       class="modal-header">
    <h1 class="modal-title">Select operations</h1>
  </div>
  <div mat-dialog-content
       class="modal-content">
    <datex-common-grid #grid
                       [isSameItemFunc]="isSameOperation"
                       [allowSelection]="allowSelection"
                       [(selected)]="selected"
                       [items]="list"
                       [totalCount]="list?.length"
                       (performGetData)="filter($event)">

      <ng-container cdkColumnDef="Name">
        <div *cdkCellDef="let item"
             class="datex-text">
          <span class="datex-text-bold">{{item.name}}</span>
          <span class="datex-text-italic">
            {{item.applicationReferenceName}}
          </span>
        </div>
      </ng-container>

      <ng-container cdkColumnDef="Description">
        <div *cdkCellDef="let item"
             class="datex-text">{{item.description}}</div>
      </ng-container>

    </datex-common-grid>
  </div>
  <div mat-dialog-actions
       class="modal-toolbar commands">
    <button mat-button
            class="datex-button primary"
            (click)="onSaveClicked()">Add</button>
    <button mat-button
            class="datex-button secondary"
            (click)="onCancelClicked()">
      Cancel
    </button>
  </div>
</div>